import { Controller } from "@hotwired/stimulus";
import L from "leaflet";

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
  };

  connect() {
    this.initMap();
  }

  initMap() {
    if (!this.hasLatValue || !this.hasLngValue) return;

    const lat = this.latValue;
    const lng = this.lngValue;

    this.map = L.map(this.element, {
      center: [lat, lng],
      zoom: 15,
      zoomControl: true,
      scrollWheelZoom: false,
      dragging: false, // Make read-only
      doubleClickZoom: false,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);

    // Fix default marker icon issues with missing assets in esbuild
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
      iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
    });

    L.marker([lat, lng]).addTo(this.map);
  }

  disconnect() {
    if (this.map) {
      this.map.remove();
    }
  }
}
